import { ArrayHelper, DynamicTableHelper } from "@workspace/common";

const INTERVIEW_INITIAL_OPTIONS = [
  {
    label: "Status",
    value: "status",
    sort: true,
    sortValue: "status",
  },
  {
    label: "Client Name",
    value: "job.jobSubmissionData.accountName",
    sort: true,
    sortValue: "job.job_submission_data.accountName",
  },
];

const INTERVIEW_MANDATORY_OPTIONS = [
  {
    label: "Job Title",
    value: "job.jobSubmissionData.jobTitle",
    sort: true,
    sortValue: "job.job_submission_data.jobTitle",
  },
  {
    label: "Candidate Name",
    value: "candidate.candidateSubmissionData.firstName",
    sort: true,
    sortValue: "candidate.candidate_submission_data.firstName",
  },
  {
    label: "Email",
    value: "candidate.candidateSubmissionData.email",
    sort: true,
    sortValue: "candidate.candidate_submission_data.email",
  },
  {
    label: "Date of Interview",
    value: "fromDate",
    sort: true,
    sortValue: "from_date",
  },
];

const INTERVIEW_MAIN_FIELDS = [
  {
    label: "Created By",
    value: "createdByName",
    sort: true,
    sortValue: "created_by",
  },
  {
    label: "Updated By",
    value: "updatedByName",
    sort: true,
    sortValue: "updated_by",
  },
  {
    label: "Created At",
    value: "createdAt",
    sort: true,
    sortValue: "created_at",
  },
  {
    label: "Updated At",
    value: "updatedAt",
    sort: true,
    sortValue: "updated_at",
  },
];

const INTERVIEW_OPTION_FIELDS = [
  {
    label: "Title",
    value: "title",
    sort: true,
    sortValue: "title",
  },
  {
    label: "Attendees",
    value: "attendees",
    sort: true,
    sortValue: "attendees",
  },
  {
    label: "Meeting Type",
    value: "meetingType",
    sort: true,
    sortValue: "meeting_type",
  },
  {
    label: "Job Title",
    value: "job.jobSubmissionData.jobTitle",
    sort: true,
    sortValue: "job.job_submission_data.jobTitle",
  },
  {
    label: "Work Type",
    value: "job.jobSubmissionData.workType",
    sort: true,
    sortValue: "job.job_submission_data.workType",
  },
  {
    label: "Job Status",
    value: "job.jobSubmissionData.jobStatus",
    sort: true,
    sortValue: "job.job_submission_data.jobStatus",
  },
  {
    label: "Account Owner",
    value: "job.jobSubmissionData.accountOwner",
    sort: true,
    sortValue: "job.job_submission_data.accountOwner",
  },
  {
    label: "No. of Headcounts",
    value: "job.jobSubmissionData.noofheadcounts",
    sort: true,
    sortValue: "job.job_submission_data.noofheadcounts",
  },
  {
    label: "Job Description",
    value: "job.jobSubmissionData.Jobdescription",
    sort: true,
    sortValue: "job.job_submission_data.Jobdescription",
  },
  {
    label: "Security Clearance",
    value: "job.jobSubmissionData.securityClearance",
    sort: true,
    sortValue: "job.job_submission_data.securityClearance",
  },
  {
    label: "Target Closing Date",
    value: "job.jobSubmissionData.targetClosingDate",
    sort: true,
    sortValue: "job.job_submission_data.targetClosingDate",
  },
  {
    label: "Gender",
    value: "candidate.candidateSubmissionData.gender",
    sort: true,
    sortValue: "candidate.candidate_submission_data.gender",
  },
  {
    label: "Skill 1",
    value: "candidate.candidateSubmissionData.skill1",
    sort: true,
    sortValue: "candidate.candidate_submission_data.skill1",
  },
  {
    label: "Skill 2",
    value: "candidate.candidateSubmissionData.skill2",
    sort: true,
    sortValue: "candidate.candidate_submission_data.skill2",
  },
  {
    label: "Skill 3",
    value: "candidate.candidateSubmissionData.skill3",
    sort: true,
    sortValue: "candidate.candidate_submission_data.skill3",
  },
  {
    label: "Visa Status",
    value: "candidate.candidateSubmissionData.visaStatus",
    sort: true,
    sortValue: "candidate.candidate_submission_data.visaStatus",
  },
  {
    label: "Candidate ID",
    value: "candidate.candidateSubmissionData.candidateId",
    sort: true,
    sortValue: "candidate.candidate_submission_data.candidateId",
  },
  {
    label: "Email Output",
    value: "candidate.candidateSubmissionData.emailOutput",
    sort: true,
    sortValue: "candidate.candidate_submission_data.emailOutput",
  },
  {
    label: "Notice Period",
    value: "candidate.candidateSubmissionData.noticePeriod",
    sort: true,
    sortValue: "candidate.candidate_submission_data.noticePeriod",
  },
  {
    label: "Primary Skill",
    value: "candidate.candidateSubmissionData.primarySkill",
    sort: true,
    sortValue: "candidate.candidate_submission_data.primarySkill",
  },
  {
    label: "Referrer Name",
    value: "candidate.candidateSubmissionData.referrerName",
    sort: true,
    sortValue: "candidate.candidate_submission_data.referrerName",
  },
  {
    label: "Candidate Owner",
    value: "candidate.candidateSubmissionData.candidateOwner",
    sort: true,
    sortValue: "candidate.candidate_submission_data.candidateOwner",
  },
  {
    label: "Profile Summary",
    value: "candidate.candidateSubmissionData.profileSummary",
    sort: true,
    sortValue: "candidate.candidate_submission_data.profileSummary",
  },
  {
    label: "Candidate Source",
    value: "candidate.candidateSubmissionData.candidateSource",
    sort: true,
    sortValue: "candidate.candidate_submission_data.candidateSource",
  },
  {
    label: "Current Employer",
    value: "candidate.candidateSubmissionData.currentEmployer",
    sort: true,
    sortValue: "candidate.candidate_submission_data.currentEmployer",
  },
  {
    label: "Current Location",
    value: "candidate.candidateSubmissionData.currentLocation",
    sort: true,
    sortValue: "candidate.candidate_submission_data.currentLocation",
  },
  {
    label: "Reason For Change",
    value: "candidate.candidateSubmissionData.reasonForChange",
    sort: true,
    sortValue: "candidate.candidate_submission_data.reasonForChange",
  },
  {
    label: "Total Experience",
    value: "candidate.candidateSubmissionData.totalExperience",
    sort: true,
    sortValue: "candidate.candidate_submission_data.totalExperience",
  },
  {
    label: "Relevant Experience",
    value: "candidate.candidateSubmissionData.relevantExperience",
    sort: true,
    sortValue: "candidate.candidate_submission_data.relevantExperience",
  },
  {
    label: "Candidate Nationality",
    value: "candidate.candidateSubmissionData.candidateNationality",
    sort: true,
    sortValue: "candidate.candidate_submission_data.candidateNationality",
  },
  {
    label: "Current Position Title",
    value: "candidate.candidateSubmissionData.currentPositionTitle",
    sort: true,
    sortValue: "candidate.candidate_submission_data.currentPositionTitle",
  },
  {
    label: "Current Salary",
    value: "candidate.candidateSubmissionData.candidateCurrentSalary",
    sort: true,
    sortValue: "candidate.candidate_submission_data.candidateCurrentSalary",
  },
  {
    label: "Expected Salary",
    value: "candidate.candidateSubmissionData.candidateExpectedSalary",
    sort: true,
    sortValue: "candidate.candidate_submission_data.candidateExpectedSalary",
  },
  {
    label: "Cancellation Reason",
    value: "cancellationReason",
    sort: true,
    sortValue: "cancellation_reason",
  },
  {
    label: "Logs Comment",
    value: "logsComment",
    sort: true,
    sortValue: "logs_comment",
  },
  {
    label: "Time of Interview",
    value: "fromTime",
    sort: true,
    sortValue: "from_time",
  },
  {
    label: "Interview end date",
    value: "toDate",
    sort: true,
    sortValue: "to_date",
  },
  {
    label: "Interview end time",
    value: "toTime",
    sort: true,
    sortValue: "to_time",
  },
];

const generateInterviewFields = (candidateForm, jobForm) => {
  const fields = [...INTERVIEW_MAIN_FIELDS];
  if (candidateForm) {
    const candidateOptions = DynamicTableHelper.buildOptionsArray(
      candidateForm?.formSchema,
      "candidate.candidateSubmissionData",
      "candidate.candidate_submission_data",
      "Candidate"
    );
    fields.push(...candidateOptions);
  }

  if (jobForm) {
    const jobOptions = DynamicTableHelper.buildOptionsArray(
      jobForm?.formSchema,
      "job.jobSubmissionData",
      "job.job_submission_data",
      "Job"
    );
    fields.push(...jobOptions);
  }
  // Remove duplicate value in the object of array. Keep the first
  const fieldsNew = fields.filter(
    (field, index, self) =>
      index === self.findIndex((t) => t.value === field.value)
  );

  ArrayHelper.sortArrayObjIcase(fieldsNew, "label");

  return fieldsNew;
};

const datePickerConstants = [
  {
    Today: {
      from: new Date(),
      to: new Date(),
    },
  },
  {
    "This Week": {
      from: (() => {
        const today = new Date();
        const dayOfWeek = today.getDay() || 7; // Treat Sunday (0) as 7
        const fromDate = new Date(today);
        fromDate.setDate(today.getDate() - dayOfWeek + 1);
        fromDate.setHours(0, 0, 0, 0);
        return fromDate;
      })(),
      to: (() => {
        const today = new Date();
        const dayOfWeek = today.getDay() || 7;
        const toDate = new Date(today);
        toDate.setDate(today.getDate() - dayOfWeek + 7);
        toDate.setHours(23, 59, 59, 999);
        return toDate;
      })(),
    },
  },
  {
    "This Month": {
      from: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
      to: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0),
    },
  },
  {
    "This Year": {
      from: new Date(new Date().getFullYear(), 0, 1), // Start from January 1st of the current year
      to: new Date(new Date().getFullYear(), 11, 31),
    },
  },
  {
    "Last Week": {
      from: (() => {
        const today = new Date();
        const dayOfWeek = today.getDay() || 7;
        const fromDate = new Date(today);
        fromDate.setDate(today.getDate() - dayOfWeek - 6);
        fromDate.setHours(0, 0, 0, 0);
        return fromDate;
      })(),
      to: (() => {
        const today = new Date();
        const dayOfWeek = today.getDay() || 7;
        const toDate = new Date(today);
        toDate.setDate(today.getDate() - dayOfWeek);
        toDate.setHours(23, 59, 59, 999);
        return toDate;
      })(),
    },
  },
  {
    "Last Month": {
      from: new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1),
      to: new Date(new Date().getFullYear(), new Date().getMonth(), 0),
    },
  },
  {
    "Last Year": {
      from: new Date(new Date().getFullYear() - 1, 0, 1),
      to: new Date(new Date().getFullYear() - 1, 11, 31),
    },
  },
  {
    "Custom Range": {
      from: null,
      to: null,
    },
  },
];

const statusMapping = {
  "All Interview": "ALL",
  Scheduled: "ALL",
  "Re-scheduled": "RESCHEDULED",
  Completed: "COMPLETED",
  Cancelled: "CANCELLED",
};

export {
  INTERVIEW_INITIAL_OPTIONS,
  INTERVIEW_MANDATORY_OPTIONS,
  INTERVIEW_OPTION_FIELDS,
  generateInterviewFields,
  datePickerConstants,
  statusMapping,
};
